import React from 'react';
import { FaSync } from 'react-icons/fa';
import './RefreshButton.css';

const RefreshButton = ({ onRefresh, isLoading = false, disabled = false, size = 'medium' }) => {
  const handleClick = () => {
    if (!disabled && !isLoading && onRefresh) {
      onRefresh();
    }
  };

  return (
    <button 
      className={`refresh-button refresh-button--${size} ${isLoading ? 'refresh-button--loading' : ''}`}
      onClick={handleClick}
      disabled={disabled || isLoading}
      title="Refresh data"
    >
      <FaSync className={`refresh-icon ${isLoading ? 'refresh-icon--spinning' : ''}`} />
      <span className="refresh-text">Refresh</span>
    </button>
  );
};

export default RefreshButton;
